import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import MainSite from '../MainSite';
import ContactSite from '../ContactSite';
import ShopIntroSite from '../ShopIntroSite';
import PricingSiteV3 from '../PricingSiteV3';
import ApiDocSite from '../ApiDocSite';
import TermsConditionsSite from '../TermsConditionsSite';
import PrivacyPolicySite from '../PrivacyPolicySite';
import DisclaimerSite from '../DisclaimerSite';
import FaqSite from '../FaqSite';
import SeoGuyanaSite from '../SeoGuyanaSite';
import SeoSurinameSite from '../SeoSurinameSite';
import BlogSite from '../BlogSite';
import BlogDetailSite from '../BlogDetailSite';

import LoginForm from '../components/registration/LoginForm';
import LoginAgreePage from '../components/registration/LoginAgreePage';
import ResetPasswordForm from '../components/registration/ResetPasswordForm';
import SetPasswordForm from '../components/registration/SetPasswordForm';
import DeviceSignupForm from '../components/registration/DeviceSignupForm';
import InstallerSignupForm from '../components/registration/InstallerSignupForm';
import InstallerLoginForm from '../components/registration/InstallerLoginForm';
import InstallerLoginFormOld from '../components/registration/InstallerLoginFormOld';
import TestInstallerLoginForm from '../components/registration/TestInstallerLoginForm';

import OemDeviceNoAuthPage from '../OemDeviceNoAuthPage';
import TemporaryMapPage from '../TemporaryMapPage';
import TemporaryPage from '../TemporaryPage';
import ReplayPage from '../reports/ReplayPage';
import TemporaryLinkApprovePage from '../TemporaryLinkApprovePage';
import TemporaryFacilityPage from '../TemporaryFacilityPage';
import TripAccessPage from '../TripAccessPage';
import InstallerMainPage from '../InstallerMainPage';
import InstallerRatePage from '../InstallerRatePage';
import FindInstallerPage from '../FindInstallerPage';
import SmartCarCallbackPage from '../SmartCarCallbackPage';
import SmartCarV3CallbackPage from '../SmartCarV3CallbackPage';
import SmartcarV3TestPage from '../SmartcarV3TestPage';
import TeslaCallbackPage from '../TeslaCallbackPage';
import TestSite from '../TestSite';
import TestSite1 from '../TestSite1';
import OAuthAuthorizePage from '../OAuthAuthorizePage';
import OAuthGrantPage from '../OAuthGrantPage';
import ApiV1DocSite from '../ApiV1DocSite';
import TemporaryReplayPage from '../reports/TemporaryReplayPage';

export const publicRoutes = [
  <Route key="home" exact path="/" component={MainSite} />,
  <Route key="contact" exact path="/contact" component={ContactSite} />,
  <Route key="shop-intro" exact path="/shop-intro" component={ShopIntroSite} />,
  <Route key="pricing" exact path="/pricing" component={PricingSiteV3} />,

  <Route key="documentation" exact path="/documentation" component={ApiDocSite} />,
  <Route key="v1-documentation" exact path="/v1-documentation" component={ApiV1DocSite} />,
  <Route key="terms" exact path="/terms-conditions" component={TermsConditionsSite} />,
  <Route key="privacy" exact path="/privacy-policy" component={PrivacyPolicySite} />,
  <Route key="disclaimer" exact path="/disclaimer" component={DisclaimerSite} />,
  <Route key="faq" exact path="/questions-answers" component={FaqSite} />,

  <Route key="seo-guyana" exact path="/country/guyana" component={SeoGuyanaSite} />,
  <Route key="seo-suriname" exact path="/country/suriname" component={SeoSurinameSite} />,

  <Route key="blog" exact path="/blog" component={BlogSite} />,
  // <Route key="article" exact path="/article/:slug?" component={BlogDetailSite} />,

  <Route key="login" exact path="/login" component={LoginForm} />,
  <Route key="login-agree" exact path="/login-agree" component={LoginAgreePage} />,
  <Route key="reset-password" exact path="/reset-password" component={ResetPasswordForm} />,
  <Route key="set-password" exact path="/set-password" component={SetPasswordForm} />,

  <Route key="device-signup" exact path="/device-signup" component={DeviceSignupForm} />,

  <Route key="oem-signup" exact path="/oem-signup" component={OemDeviceNoAuthPage} />,
  <Route key="oem" exact path="/oem" component={OemDeviceNoAuthPage} />,
  <Route key="OEM" exact path="/OEM" component={OemDeviceNoAuthPage} />,

  <Route key="temporary-map" exact path="/temporary-map/:shareUrl?" component={TemporaryMapPage} />,
  <Route key="temporary" exact path="/temporary/:shareUrl?" component={TemporaryPage} />,
  <Route key="temporary-replay" exact path="/temporary-replay/:shareUrl?" component={TemporaryReplayPage} />,
  <Route key="link-approve" exact path="/link/:approve_type/:action/:shareUrl" component={TemporaryLinkApprovePage} />,

  <Route key="facility" exact path="/facility/:shareUrl?" component={TemporaryFacilityPage} />,

  <Route key="trip-access" exact path="/trip_access" component={TripAccessPage} />,

  <Route key="installer-signup" exact path="/installer-signup" component={InstallerSignupForm} />,
  <Route key="installer-login" exact path="/installer-login" component={InstallerLoginForm} />,
  <Route key="installer-login-old" exact path="/installer-login-old" component={InstallerLoginFormOld} />,

  <Route key="installer-main" exact path="/installer-main" component={InstallerMainPage} />,
  <Route key="installer-rate" exact path="/installer-rate" component={InstallerRatePage} />,
  <Route key="find-installer" exact path="/find-installer" component={FindInstallerPage} />,

  <Route key="test-installer-login" exact path="/test-installer-login" component={TestInstallerLoginForm} />,
  <Route key="test-installer-main" exact path="/test-installer-main" component={InstallerMainPage} />,

  <Route key="smartcar-callback" exact path="/smartcar-callback" component={SmartCarCallbackPage} />,
  <Route key="smartcar-v3-callback" exact path="/smartcar-v3-callback" component={SmartCarV3CallbackPage} />,
  <Route key="smartcar-v3-test" exact path="/smartcar-v3-test" component={SmartcarV3TestPage} />,
  <Route key="tesla-callback" exact path="/tesla-callback" component={TeslaCallbackPage} />,

  <Route key="test" exact path="/test" component={TestSite} />,
  <Route key="test1" exact path="/test1" component={TestSite1} />,

  <Route key="oauth-authorize" exact path="/oauth/authorize" component={OAuthAuthorizePage} />,
  <Route key="oauth-grant" exact path="/oauth/grant" component={OAuthGrantPage} />,
  <Redirect key="oauth-documentation" from="/oauth-documentation" to="/documentation#oauth" />,
];
